import EventBus from "eventing-bus"
import {
  constants,
  getModelsArr,
  getControls,
  getCurrBoard,
  getCurrSection,
  setCurrSection,
  getTruckModelsArr,
  getCurrTruck,
  getWheelModelsArr,
  getCurrWheel,
  getPrevSection,
} from "../model"
import gsap from "gsap"
import { createDivEl, createImgEl } from "../utils/common"

let viewEl = null,
  ulEl = null,
  totPriceEl = null,
  totPrice = 0,
  listItemsArr = [],
  addCartBtn = null

const handleSectionchanged = () => {
  viewEl = document.querySelector("#summary-view")
  ulEl = viewEl.querySelector(".col ul")
  totPriceEl = viewEl.querySelector(".col .total")
  addCartBtn = viewEl.querySelector(".add-to-cart-btn")
  totPrice = 0

  if (getCurrSection() === 3) {
    populateList()
    addEventListeners()
    setTimeout(() => {
      viewEl.classList.add("show")
    }, 5100)
  }
  if (
    (getPrevSection() === 3 && getCurrSection() === 0) ||
    (getPrevSection() === 3 && getCurrSection() === 1) ||
    (getPrevSection() === 3 && getCurrSection() === 2)
  ) {
    viewEl.classList.remove("show")
    setTimeout(() => {
      listItemsArr.map((d) => {
        ulEl.removeChild(d)
      })
      listItemsArr = []
    }, 1000)
    removeEventListeners()
  }

  addCartBtn.addEventListener("click", handleAddToCartBtnClick)
}

const handleAddToCartBtnClick = () => {
  const duration = 0.05
  EventBus.publish(constants.ADD_TO_CART_PRESSED)
  gsap.to(addCartBtn, { duration, scale: 0.3, ease: "power4.out" })
  gsap.to(addCartBtn, { duration, scale: 1, delay: duration, ease: "power4.inOut" })
}

const handleEditBtnClick = (e) => {
  setCurrSection(Number(e.currentTarget.id))
}

const addEventListeners = () => {
  const editBtns = viewEl.querySelectorAll("ul .edit")
  for (let i = 0; i < editBtns.length; i++) {
    editBtns[i].addEventListener("click", handleEditBtnClick)
    editBtns[i].id = i
  }
}

const removeEventListeners = () => {
  const editBtns = viewEl.querySelectorAll("ul .edit")
  for (let i = 0; i < editBtns.length; i++) {
    editBtns[i].removeEventListener("click", handleEditBtnClick)
  }
}

const handleProductZoomClicked = (bool) => {
  if (bool) {
    viewEl.classList.remove("show")
    getControls().enabled = true
  } else {
    viewEl.classList.add("show")
    getControls().enabled = false
  }
}

EventBus.on(constants.SECTION_CHANGED, handleSectionchanged)
EventBus.on(constants.PLAY_PRODUCT_ZOOM, handleProductZoomClicked)

const populateList = () => {
  const orderData = [getModelsArr()[getCurrBoard()], getTruckModelsArr()[getCurrTruck()], getWheelModelsArr()[getCurrWheel()]]

  for (let i = 0; i < orderData.length; i++) {
    const listItem = document.createElement("li")
    listItem.className = "item"
    ulEl.appendChild(listItem)
    listItemsArr.push(listItem)

    // Image
    const imgPath = orderData[i].thumbSrc
    const img = require("../assets/images/" + imgPath)
    listItem.appendChild(createImgEl(img))

    // Name
    const name = orderData[i].name
    listItem.appendChild(createDivEl(name, "title"))

    // Price
    const price = "$" + orderData[i].price + ".00"
    listItem.appendChild(createDivEl(price, "price"))
    totPrice += Number(orderData[i].price)

    // Edit
    const editIcon = require("../assets/images/edit.png")
    listItem.appendChild(createImgEl(editIcon, "edit"))
  }

  // Bones Red Bearings
  const listItem1 = document.createElement("li")
  listItem1.className = "item"
  ulEl.appendChild(listItem1)
  const img1 = require("../assets/images/bones-reds.png")
  listItem1.appendChild(createImgEl(img1))
  listItem1.appendChild(createDivEl("Bones Reds Bearings", "title"))
  listItem1.appendChild(createDivEl("$29.00", "price"))
  listItem1.appendChild(createDivEl("", "edit"))
  totPrice += 29

  // Grip & Tape
  const listItem2 = document.createElement("li")
  listItem2.className = "item"
  ulEl.appendChild(listItem2)
  const img2 = require("../assets/images/grip-tape-thumb.png")
  listItem2.appendChild(createImgEl(img2))
  listItem2.appendChild(createDivEl("Independent Hardware & Grip Tape", "title"))
  listItem2.appendChild(createDivEl("$11.00", "price"))
  listItem2.appendChild(createDivEl("", "edit"))
  totPrice += 11

  listItemsArr.push(listItem1)
  listItemsArr.push(listItem2)

  totPriceEl.innerHTML = "$" + totPrice + ".00"
}

// const createDivEl = (txt, clsName) => {
//   const divEl = document.createElement("div")
//   divEl.className = clsName
//   divEl.innerHTML = txt
//   return divEl
// }

// const createImgEl = (img, clsName) => {
//   const imgEl = document.createElement("img")
//   imgEl.className = clsName
//   imgEl.src = img
//   return imgEl
// }
